import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Modal,
  Row,
  Col,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import Input from './Input';
import AgencyInput from './AgencyInput';

import { createCampaign } from '../../../actions/campaign';

class AddCampaign extends React.PureComponent {
  close = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'CLOSE_MODAL', modal: 'addCampaignOpen' });
    dispatch({ type: 'CLEAR_ADD_CAMPAIGN' });
  };

  handleSave = () => {
    const { dispatch, values } = this.props;

    dispatch({ type: 'SET_CAMPAIGN_SAVING', payload: true });

    let newValues = values;
    if (values.agencies.length === 0) {
      newValues = Object.keys(values)
        .filter((value) => value !== 'agencies')
        .reduce((obj, key) => ({
          ...obj,
          [key]: values[key],
        }), {});
    }

    createCampaign({
      ...newValues,
    }).then(this.close).catch(() => {
      dispatch({ type: 'SET_CAMPAIGN_SAVING', payload: false });
    });
  };

  render() {
    const {
      isOpen,
      saving,
      validation,
      validations,
    } = this.props;

    const erroring = !Object.values(validations).reduce((prev, curr) => prev && curr, true);

    return (
      <Modal
        isOpen={isOpen}
        toggle={this.close}
        className="mw-100 mx-xl-7 mx-lg-6 mx-4 fade-in"
        zIndex="100000"
      >
        <div className="px-5 py-3 h4 d-flex justify-content-between align-items-center border-bottom">
          Create Campaign
          <Button color="white" onClick={this.close}>
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </Button>
        </div>
        <Row className="px-5 py-3">
          <Col>
            <Input
              id="name"
              label="Name:"
              pattern={validation.campaign_name}
            />
          </Col>
        </Row>
        <Row className="px-5 py-3">
          <Col>
            <Input
              id="start"
              label="Start Date (format: YYYY-MM-DD)"
              pattern={validation.date}
              type="date"
            />
            <Input
              id="end"
              label="End Date (format: YYYY-MM-DD)"
              pattern={validation.date}
              type="date"
            />
            <AgencyInput />
          </Col>
          <Col>
            <Input
              id="q_to_shoppers"
              label="Percentage of Quotes Saved as % of Beneficiaries:"
              pattern={validation.campaign_number_value}
            />
            <Input
              id="es_to_quotes"
              label="Enrollments Started as % of Quotes Saved:"
              pattern={validation.campaign_number_value}
            />
            <Input
              id="ec_to_enrollments"
              label="Enrollments Completed as % of Enrollments Started:"
              pattern={validation.campaign_number_value}
            />
            <Input
              id="es_to_shoppers"
              label="Enrollments Started as % of Beneficiaries:"
              pattern={validation.campaign_number_value}
            />
            <Input
              id="ec_to_shoppers"
              label="Enrollments Completed as % of Beneficiaries:"
              pattern={validation.campaign_number_value}
            />
          </Col>
        </Row>
        <div className="px-5 pt-1 pb-5 justify-content-start">
          <Button
            color="primary"
            className="me-3 text-white px-4"
            onClick={this.handleSave}
            disabled={saving || erroring}
          >
            <FontAwesomeIcon icon={faSave} size="lg" className="me-2" />
            Save
            {saving && (
              <Spinner size="sm" className="ms-2" />
            )}
          </Button>
          <Button
            color="dark"
            outline
            className="px-4"
            onClick={this.close}
            disabled={saving}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
            Cancel
          </Button>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (store) => ({
  isOpen: store.modals.addCampaignOpen,
  saving: store.addcampaign.saving,
  values: store.addcampaign.values,
  validation: store.theme.validation,
  validations: store.addcampaign.validations,
});

export default connect(mapStateToProps)(AddCampaign);
